import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { toast } from 'react-toastify';
import { ModalGeneric } from '../../../../interfaces';
import { Modal } from '../Modal';
import "./ValidationOTP.css";
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Message, _single } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    onValidate: Function;
    _text?: string;
    _nit?:number;
    _idAccountExt?:number;
}

export const ValidationOtp = forwardRef(({ onValidate, _text,_nit ,_idAccountExt}: Props, ref) => {

    const { instance } = useDataBean(_Message);
    const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const [otpValues, setOtpValues] = useState(Array(6).fill(''));
    const [timer, setTimer] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(true);
    const text = _text ?? "Te hemos enviado un código de verificación a tu correo electrónico.";
    const [modal, setModal] = useState<ModalGeneric>({
        name: 'Queremos validar tu identidad',
        tabIndex: -1,
        view: false,
        btnClose: true,
        btnSubmit: true,
        format: 'modal-md',
    });

    useEffect(() => {
        if (modal.view === true) {
            sendOTP();

        }
    }, [modal.view])

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
            return () => clearInterval(interval);
        } else {
            setIsResendEnabled(true);
        }
    }, [timer]);

    const handleChange = (value: string, index: number) => {
        const newOtpValues = [...otpValues];
        newOtpValues[index] = value;
        setOtpValues(newOtpValues);
        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const sendOTP = () => {
        if (_single.getAccount().Nit) 
            {
            let nit = _nit ? _nit : _single.getAccount().Nit;
            instance.sendOTPAccountByNit(nit).then(
                (resp) => {
                    toast.success('Codigo de Verificación Enviado Exitosamente.');
                    setTimer(60);
                    setIsResendEnabled(false);
                }
            ).catch(
                err => { toast.error("No se pudo enviar el Codigo de Verificación") }
            )
        } else {
            toast.error("No se pudo generar el Codigo de Verificación")
        }
    }

    useImperativeHandle(ref, () => ({
        openOTPModal,
    }));

    const openOTPModal = (tittle?: string) => {
        setOtpValues(Array(6).fill(''));
        setModal({ ...modal, view: true, name: tittle ?? "Queremos validar tu identidad" });
    };

    const validateOTP = (code: string) => {
        instance.validateOTPAccount(_idAccountExt ?? _single.getAccountID(), code).then(
            (resp) => {
                console.log(resp)
                if (resp.Valid === true) {
                    setModal({ ...modal, view: false });
                    toast.success('Confirmacion Exitosa');
                    if (onValidate) {
                        onValidate()
                    }
                } else {
                    toast.error("Codigo OTP Incorrecto")
                }
            }
        ).catch(
            err => { toast.error("Hubo un inconveniente, intentelo nuevamente mas tarde") }
        )
    }

    const handleResend = () => {
        if (isResendEnabled) {
            sendOTP();
            setTimer(60);
            setIsResendEnabled(false);
        }
    };

    const handleSubmit = () => {
        const otpCode = otpValues.join('');
        if (otpCode.length === 6) {
            validateOTP(otpCode);
        } else {
            toast.error('Por favor completa el código OTP.');
        }
    };

    return (
        <Modal modal={modal} updateModal={setModal} eventModal={() => handleSubmit()} onSubmitLabel="Confirmar">
            <div className="row">
                <div className="text-center">
                    <div className="title">OTP - Codigo de Verificación</div>
                    <p className="message_otp">{text}</p>
                </div>
                <div className="col-md-12 inputs">
                    {otpValues.map((_, index) => (
                        <input
                            key={index}
                            type="text"
                            maxLength={1}
                            ref={(el) => (inputRefs.current[index] = el)}
                            value={otpValues[index]}
                            onChange={(e) => handleChange(e.target.value, index)}
                            onKeyDown={(e) => {
                                if (e.key === 'Backspace') {
                                    if (otpValues[index] === '' && index > 0) {
                                        inputRefs.current[index - 1]?.focus();
                                    } else {
                                        handleChange('', index);
                                    }
                                } else if (e.key === 'ArrowRight' && index < inputRefs.current.length - 1) {
                                    inputRefs.current[index + 1]?.focus();
                                } else if (e.key === 'ArrowLeft' && index > 0) {
                                    inputRefs.current[index - 1]?.focus();
                                } else if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            className="otp-input"
                        />
                    ))}
                </div>
                <div className="col-md-12 mt-4">
                    <p className="resendNote">
                        ¿No reicibiste el OTP? {isResendEnabled ? '' : ` - (${timer}s)`}
                        <button
                            className="resendBtn"
                            onClick={handleResend}
                            disabled={!isResendEnabled}
                        >
                            Reenviar Codigo
                        </button>
                    </p>
                </div>
            </div>
        </Modal>
    );
});